import { CustomerTestimonial } from "./CustomerTestimonial";

export const UniversalRender = CustomerTestimonial;
